import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
  configLoading: false,
  configSuccess: false,
  configError: false,
};

const configTimeSheetReducer = (state = initialState, action) => {
  switch (action.type) {

    case types.CONFIG_TIME_SHEET:
      return {
        success: false,
        ...(action?.payload || {}),
      };
    case types.CONFIG_TIME_SHEET_INTI:
      return {
        ...state,
        success: false,
        ...(action?.payload || {}),
      };

    case types.CONFIG_TIME_SHEET_REQUESTED:
      return {
        ...state,
        success: false,
        loading: true,
        error: false,
      };
    case types.CONFIG_TIME_SHEET_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        error: false,
      };
    case types.CONFIG_TIME_SHEET_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };
    case types.GET_CONFIG_TIME_SHEET_INIT:
      return {
        ...state,
        configLoading: true,
        configSuccess: false,
        configError: false,
      };
    case types.GET_CONFIG_TIME_SHEET_SUCCESS:
      return {
        configLoading: false,
        configSuccess: true,
        configError: false,
        ...(action?.payload || {}),
      };
    case types.GET_CONFIG_TIME_SHEET_FAILURE:
      return {
        ...state,
        configLoading: false,
        configSuccess: false,
        configError: true,
      };
    default:
      return state;
  }
};
export default configTimeSheetReducer;
